export const ADD_WORKFLOW_EDGE_EVENT = 'profase:add-workflow-edge';

export function addWorkflowEdge(source: unknown, target: unknown): void {
  const from = String(source ?? '').trim();
  const to = String(target ?? '').trim();
  if (!from || !to) return;
  window.dispatchEvent(
    new CustomEvent(ADD_WORKFLOW_EDGE_EVENT, { detail: { source: from, target: to } }),
  );
}

if (typeof window !== 'undefined') {
  window.addEdge = addWorkflowEdge;
}
